import { z } from 'zod';
import { SystemRole } from '../types/index.js';
export const createUserSchema = z.object({
    email: z.string().email(),
    name: z.string().min(1).max(255),
    systemRole: z.nativeEnum(SystemRole),
    phone: z.string().max(50).optional(),
    address: z.string().max(500).optional(),
    googleId: z.string().optional(),
});
// Update fields are nullable: the edit panels send null to clear a field
export const updateUserSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    phone: z.string().max(50).nullable().optional(),
    address: z.string().max(500).nullable().optional(),
    systemRole: z.nativeEnum(SystemRole).optional(),
    isActive: z.boolean().optional(),
});
//# sourceMappingURL=user.js.map